module.exports = __webpack_public_path__ + "img/JAOC_POP_SquidInkSauce_square.c20f1a21.png";